// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ccKD","label":"Section_label__3Hfbp","contentWrap":"Section_contentWrap__1jT1x","footer":"Section_footer__1kC2G","footerInner":"Section_footerInner__ADas5"};